import type { FaireProductEntity } from "../../entity_types/product";

export const p_9f3gtfgbp7: FaireProductEntity = {
  token: "p_9f3gtfgbp7",
  type: "product",
  name: "Olivetti Lettera Journal",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/de0095ae36cfa0bc7648bff422700099b975d44a597012bd13a3521d3438b5b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/504bb54bdaa879389e09a8756f9b49e8ad2eae76f857361a9956b2d0c0cc8c2c.jpeg"
  ],
  priceDollars: 8,
  description: "Celebrate the enduring legacy of the Olivetti Lettera, one of the most beloved portable typewriters of the 20th century and a lasting symbol of creativity, travel, and thoughtful communication. This beautifully crafted journal features artwork drawn from original Olivetti Lettera advertisements, blending vintage graphic design with modern functionality. With a clean, minimalist layout and a durable, elegant cover, it offers a tactile, inspiring space for drafting ideas, capturing reflections, or crafting your next great story.",
  tags: [],
  msrpDollars: 15.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:38.599Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
